document.addEventListener('DOMContentLoaded', function () {
  const textField = document.querySelector(
    '[data-custom-option-input="custom_option_aUTHdH"]'
  );

  if (!textField) return;

  const limit = 600;

  textField.setAttribute('maxlength', limit);

  const counter = document.createElement('small');
  counter.className = 'character-counter';
  counter.textContent = `0 / ${limit} caracteres`;

  textField.insertAdjacentElement('afterend', counter);

  const updateCounter = () => {
    counter.textContent = `${textField.value.length} / ${limit} caracteres`;
  };

  textField.addEventListener('input', updateCounter);

  // Por si el campo ya viene relleno
  updateCounter();
});